// feature-slider.js
(function(){
  const SELECTOR = '[data-feature-slider]';
  const MOBILE_BREAKPOINT = 768;

  function initSlider(slider) {
    if (!slider || slider.__fs_inited) return;
    slider.__fs_inited = true;

    // Make sure container is horizontally scrollable on small screens
    function isMobileView() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    // Pointer drag (works for touch and mouse)
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let lastTouchTime = 0;

    function onPointerDown(e) {
      // ignore right click or non-primary buttons
      if (e.button && e.button !== 0) return;
      isDown = true;
      slider.classList.add('fs-grabbing');
      startX = (e.touches ? e.touches[0].pageX : e.pageX) - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      lastTouchTime = Date.now();
    }

    function onPointerMove(e) {
      if (!isDown) return;
      const x = (e.touches ? e.touches[0].pageX : e.pageX) - slider.offsetLeft;
      const walk = (startX - x) * 1.2; // sensitivity
      slider.scrollLeft = scrollLeft + walk;
    }

    function onPointerUp() {
      isDown = false;
      slider.classList.remove('fs-grabbing');
    }

    // Wheel support for horizontal scroll
    function onWheel(e) {
      if (!isMobileView()) return;
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        // vertical wheel -> translate to horizontal
        e.preventDefault();
        slider.scrollLeft += e.deltaY;
      }
    }

    // Add event listeners (touch & mouse)
    slider.addEventListener('touchstart', onPointerDown, { passive: true });
    slider.addEventListener('touchmove', onPointerMove, { passive: true });
    slider.addEventListener('touchend', onPointerUp, { passive: true });

    slider.addEventListener('mousedown', (e) => {
      // only enable mouse drag on small screens to avoid interfering with desktop layout
      if (!isMobileView()) return;
      onPointerDown(e);
    });
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', onPointerUp);

    slider.addEventListener('wheel', onWheel, { passive: false });

    // If content is too short, center it on desktop
    function applyDesktopLayout() {
      if (!isMobileView()) {
        slider.style.overflowX = 'visible';
      } else {
        slider.style.overflowX = '';
      }
    }

    applyDesktopLayout();
    window.addEventListener('resize', applyDesktopLayout);

    // Optional: snapping to cards on touchend (small screens)
    let snapTimeout = null;
    slider.addEventListener('touchend', () => {
      clearTimeout(snapTimeout);
      snapTimeout = setTimeout(() => {
        if (!isMobileView()) return;
        // find nearest card and snap
        const cards = Array.from(slider.children);
        if (!cards.length) return;
        const sliderCenter = slider.scrollLeft + slider.clientWidth / 2;
        let nearest = cards[0];
        let minDist = Infinity;
        cards.forEach(c => {
          const cLeft = c.offsetLeft + c.clientWidth / 2;
          const dist = Math.abs(cLeft - sliderCenter);
          if (dist < minDist) { minDist = dist; nearest = c; }
        });
        // smooth scroll so the chosen card is centered-ish
        const target = Math.max(0, nearest.offsetLeft - (slider.clientWidth - nearest.clientWidth) / 2);
        slider.scrollTo({ left: target, behavior: 'smooth' });
      }, 80);
    });

    // Accessibility: keyboard left/right when focused
    slider.setAttribute('tabindex', '0');
    slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') slider.scrollBy({ left: slider.clientWidth * 0.6, behavior: 'smooth' });
      if (e.key === 'ArrowLeft') slider.scrollBy({ left: -slider.clientWidth * 0.6, behavior: 'smooth' });
    });
  }

  // If the element does not exist yet (Shopify sections load async), observe DOM
  function waitForSliders() {
    const existing = document.querySelectorAll(SELECTOR);
    existing.forEach(initSlider);

    // MutationObserver to catch dynamically added sliders
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          if (node.matches && node.matches(SELECTOR)) initSlider(node);
          // also check descendants
          const child = node.querySelector && node.querySelector(SELECTOR);
          if (child) initSlider(child);
        }
      }
    });

    mo.observe(document.body, { childList: true, subtree: true });

    // Stop observing after 30s to avoid overhead (safety)
    setTimeout(() => mo.disconnect(), 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSliders);
  } else {
    waitForSliders();
  }
})();
